import { render } from "./TheMain.vue?vue&type=template&id=165e5103&scoped=true"
import script from "./TheMain.vue?vue&type=script&lang=js"
export * from "./TheMain.vue?vue&type=script&lang=js"

import "../../assets/css/components/UI/TheMain_scoped.css?vue&type=style&index=0&id=165e5103&scoped=true&lang=css&external"
import "./TheMain.vue?vue&type=style&index=1&id=165e5103&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-165e5103"]])

export default __exports__